import React from "react";
import ReactDOM from "react-dom/client";
import { RouterComponent } from "./router";

import "./styles/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <RouterComponent />,
);
